var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-summary',_vm._g({attrs:{"icon":"item","title":"商品分類","scroll-to-id":_vm.scrollToId,"errors":_vm.errors}},_vm.$listeners),[_vm._v(_vm._s(_vm.categories.length)+"分類")])}
var staticRenderFns = []

export { render, staticRenderFns }